jQuery(document).ready(function($) {


    // product image zoom
   	$('.zoom').elevateZoom({
		gallery:"productThumbs",
        zoomType: "inner",
        cursor: "zoom-in",
        zoomWindowFadeIn: 500,
        zoomWindowFadeOut: 750
    });

   	//product image popup
     $('body').on('click', '#productPhotoImg', function(e) {
       var images = new Array();
       //images[0] = {
       // src : document.getElementById('productPhotoImg').dataset.zoomImage,
       //  type : 'image'
       //};
         var ind = 0;
         $('#productThumbs a[data-zoom-image] img').each(function() {
           var i = {
             src : $(this).data('grande'),
             type : 'image'
           };
           //if( i.src != images[0].src ) {
             images[ind] = i;
             ind++;
           //} //else { console.log(images[0].src); }
         });
         
            
       var mPopup = $.magnificPopup.instance;
       mPopup.open({
          removalDelay: 500,
          items: images,
          gallery: {
			  enabled: true,
              navigateByImgClick: true,
              preload: [0,1],
              tLoading: 'Loading image #%curr%...',
              tPrev: 'Previous', // title for left button
              tNext: 'Next', // title for right button
              tCounter: '<span class="mfp-counter">%curr% of %total%</span>' // markup of counter
		  }
        });
		if(typeof $("#productPhotoImg").data('position') != 'undefined') {
			mPopup.goTo(parseInt($("#productPhotoImg").data('position')));
        } //else { console.log('data position not defined!'); }
        
        

       return false;
     });

  $("#productThumbs a[data-zoom-image]").click(function() {
    $("#productPhotoImg").data('position', $(this).data('position')).data('zoom-image', $(this).data('image'));
    var myVar = setInterval(function(){ // wait for fading
        var height = $(".zoom").css("height");
        $(".zoomContainer").css("height", height);
        $(".zoomContainer .zoomWindow").css("height", height);

        clearInterval(myVar);
    }, 100);
  });



  // tabs on product page description | pages |reviews
  if ($('.tab-area').length) {
  $('.tab-area').responsiveTabs({
    rotate: false,
    
     
     collapsible: 'accordion',
    
    setHash: false,
    
    disabled: [],
  });
  }

  
   

  
  
  //Reviews onClick open tab
       $('a#more-action').on('click', function() {
         $(".r-tabs .r-tabs-panel").removeClass('r-tabs-state-active').addClass('r-tabs-state-default').css({ 'display': "none" });
         $(".r-tabs .r-tabs-panel").first().removeClass('r-tabs-state-default').addClass('r-tabs-state-active').css({ 'display': "block" });
         $(".r-tabs .r-tabs-accordion-title").removeClass('r-tabs-state-active').addClass('r-tabs-state-default');
         $(".r-tabs .r-tabs-accordion-title").first().removeClass('r-tabs-state-default').addClass('r-tabs-state-active');
         $("ul.r-tabs-nav li.r-tabs-tab").removeClass('r-tabs-state-active').addClass('r-tabs-state-default');
         $("ul.r-tabs-nav li.r-tabs-tab:first-child").removeClass('r-tabs-state-default').addClass('r-tabs-state-active');
         $("ul.r-tabs-nav li.r-tabs-tab a, .r-tabs .r-tabs-accordion-title a").first().trigger('click');
       });
  
  
  
  
  //Reviews onClick open tab
       $('a#reviews-action').on('click', function() {
         $(".r-tabs .r-tabs-panel").removeClass('r-tabs-state-active').addClass('r-tabs-state-default').css({ 'display': "none" });
         $(".r-tabs .r-tabs-panel").last().removeClass('r-tabs-state-default').addClass('r-tabs-state-active').css({ 'display': "block" });
         $(".r-tabs .r-tabs-accordion-title").removeClass('r-tabs-state-active').addClass('r-tabs-state-default');
         $(".r-tabs .r-tabs-accordion-title").last().removeClass('r-tabs-state-default').addClass('r-tabs-state-active');
         $("ul.r-tabs-nav li.r-tabs-tab").removeClass('r-tabs-state-active').addClass('r-tabs-state-default');
         $("ul.r-tabs-nav li.r-tabs-tab:last-child").removeClass('r-tabs-state-default').addClass('r-tabs-state-active');
         $("ul.r-tabs-nav li.r-tabs-tab a, .r-tabs .r-tabs-accordion-title a").last().trigger('click');
       });
  
  
  
  $('a#more-action').on('click', function() {
    $("html, body").animate({
      scrollTop: $("#more-anchor").offset().top
    }, 1000);

    return false;
  });
  $('a#reviews-action').on('click', function() {
    $("html, body").animate({
      scrollTop: $("#all-reviews").offset().top
    }, 1000);

    return false;
  });
});
